export default function ChapterDetail11(props) {
  document.title = props.text + " | Arisu";
  
	return (
    <>
      <p className="indent-8">
        The King and Queen of Hearts were seated on their throne when they arrived,
        with a great crowd assembled about them—all sorts of little birds and
        beasts, as well as the whole pack of cards: the Knave was standing before them,
        in chains, with a soldier on each side to guard him; and near the King was the
        White Rabbit, with a trumpet in one hand, and a scroll of parchment in the
        other. In the very middle of the court was a table, with a large dish of tarts
        upon it: they looked so good, that it made Alice quite hungry to look at
        them—“I wish they’d get the trial done,” she thought,
        “and hand round the refreshments!” But there seemed to be no chance
        of this, so she began looking at everything about her, to pass away the time.
      </p>
      <p className="indent-8">
        Alice had never been in a court of justice before, but she had read about them
        in books, and she was quite pleased to find that she knew the name of nearly
        everything there. “That’s the judge,” she said to herself,
        “because of his great wig.”
      </p>
      <p className="indent-8">
        The judge, by the way, was the King; and as he wore his crown over the wig,
        (look at the frontispiece if you want to see how he did it,) he did not look at
        all comfortable, and it was certainly not becoming.
      </p>
      <p className="indent-8">
        “And that’s the jury-box,” thought Alice, “and those
        twelve creatures,” (she was obliged to say “creatures,” you
        see, because some of them were animals, and some were birds,) “I suppose
        they are the jurors.” She said this last word two or three times over to
        herself, being rather proud of it: for she thought, and rightly too, that very
        few little girls of her age knew the meaning of it at all. However,
        “jury-men” would have done just as well.
      </p>
      <p className="indent-8">
        The twelve jurors were all writing very busily on slates. “What are they
        doing?” Alice whispered to the Gryphon. “They can’t have
        anything to put down yet, before the trial’s begun.”
      </p>
      <p className="indent-8">
        “They’re putting down their names,” the Gryphon whispered in
        reply, “for fear they should forget them before the end of the
        trial.”
      </p>
      <p className="indent-8">
        “Stupid things!” Alice began in a loud, indignant voice, but she
        stopped hastily, for the White Rabbit cried out, “Silence in the
        court!” and the King put on his spectacles and looked anxiously round, to
        make out who was talking.
      </p>
      <p className="indent-8">
        Alice could see, as well as if she were looking over their shoulders, that all
        the jurors were writing down “stupid things!” on their slates, and
        she could even make out that one of them didn’t know how to spell
        “stupid,” and that he had to ask his neighbour to tell him.
        “A nice muddle their slates’ll be in before the trial’s
        over!” thought Alice.
      </p>
      <p className="indent-8">
        One of the jurors had a pencil that squeaked. This of course, Alice could
        <i>not</i> stand, and she went round the court and got behind him, and very
        soon found an opportunity of taking it away. She did it so quickly that the
        poor little juror (it was Bill, the Lizard) could not make out at all what had
        become of it; so, after hunting all about for it, he was obliged to write with
        one finger for the rest of the day; and this was of very little use, as it left
        no mark on the slate.
      </p>
      <p className="indent-8">
        “Herald, read the accusation!” said the King.
      </p>
      <p className="indent-8">
        On this the White Rabbit blew three blasts on the trumpet, and then unrolled
        the parchment scroll, and read as follows:—
      </p>
      <div className="grid justify-center">
        <p className="mt-2">“The Queen of Hearts, she made some tarts,</p>
        <p className="indent-8">All on a summer day:</p>
        <p>The Knave of Hearts, he stole those tarts,</p>
        <p className="indent-8 mb-2">And took them quite away!”</p>
      </div>
      <p className="indent-8">
        “Consider your verdict,” the King said to the jury.
      </p>
      <p className="indent-8">
        “Not yet, not yet!” the Rabbit hastily interrupted.
        “There’s a great deal to come before that!”
      </p>
      <p className="indent-8">
        “Call the first witness,” said the King; and the White Rabbit blew
        three blasts on the trumpet, and called out, “First witness!”
      </p>
      <p className="indent-8">
        The first witness was the Hatter. He came in with a teacup in one hand and a
        piece of bread-and-butter in the other. “I beg pardon, your
        Majesty,” he began, “for bringing these in: but I hadn’t
        quite finished my tea when I was sent for.”
      </p>
      <p className="indent-8">
        “You ought to have finished,” said the King. “When did you
        begin?”
      </p>
      <p className="indent-8">
        The Hatter looked at the March Hare, who had followed him into the court,
        arm-in-arm with the Dormouse. “Fourteenth of March, I <i>think</i> it
        was,” he said.
      </p>
      <p className="indent-8">
        “Fifteenth,” said the March Hare.
      </p>
      <p className="indent-8">
        “Sixteenth,” added the Dormouse.
      </p>
      <p className="indent-8">
        “Write that down,” the King said to the jury, and the jury eagerly
        wrote down all three dates on their slates, and then added them up, and reduced
        the answer to shillings and pence.
      </p>
      <p className="indent-8">
        “Take off your hat,” the King said to the Hatter.
      </p>
      <p className="indent-8">
        “It isn’t mine,” said the Hatter.
      </p>
      <p className="indent-8">
        “<i>Stolen!</i>” the King exclaimed, turning to the jury, who
        instantly made a memorandum of the fact.
      </p>
      <p className="indent-8">
        “I keep them to sell,” the Hatter added as an explanation;
        “I’ve none of my own. I’m a hatter.”
      </p>
      <p className="indent-8">
        Here the Queen put on her spectacles, and began staring at the Hatter, who
        turned pale and fidgeted.
      </p>
      <p className="indent-8">
        “Give your evidence,” said the King; “and don’t be
        nervous, or I’ll have you executed on the spot.”
      </p>
      <p className="indent-8">
        This did not seem to encourage the witness at all: he kept shifting from one
        foot to the other, looking uneasily at the Queen, and in his confusion he bit a
        large piece out of his teacup instead of the bread-and-butter.
      </p>
      <p className="indent-8">
        Just at this moment Alice felt a very curious sensation, which puzzled her a
        good deal until she made out what it was: she was beginning to grow larger
        again, and she thought at first she would get up and leave the court; but on
        second thoughts she decided to remain where she was as long as there was room
        for her.
      </p>
      <p className="indent-8">
        “I wish you wouldn’t squeeze so.” said the Dormouse, who was
        sitting next to her. “I can hardly breathe.”
      </p>
      <p className="indent-8">
        “I can’t help it,” said Alice very meekly: “I’m
        growing.”
      </p>
      <p className="indent-8">
        “You’ve no right to grow <i>here</i>,” said the Dormouse.
      </p>
      <p className="indent-8">
        “Don’t talk nonsense,” said Alice more boldly: “you
        know you’re growing too.”
      </p>
      <p className="indent-8">
        “Yes, but <i>I</i> grow at a reasonable pace,” said the Dormouse:
        “not in that ridiculous fashion.” And he got up very sulkily and
        crossed over to the other side of the court.
      </p>
      <p className="indent-8">
        All this time the Queen had never left off staring at the Hatter, and, just as
        the Dormouse crossed the court, she said to one of the officers of the court,
        “Bring me the list of the singers in the last concert!” on which
        the wretched Hatter trembled so, that he shook both his shoes off.
      </p>
      <p className="indent-8">
        “Give your evidence,” the King repeated angrily, “or
        I’ll have you executed, whether you’re nervous or not.”
      </p>
      <p className="indent-8">
        “I’m a poor man, your Majesty,” the Hatter began, in a
        trembling voice, “—and I hadn’t begun my tea—not above
        a week or so—and what with the bread-and-butter getting so thin—and
        the twinkling of the tea—”
      </p>
      <p className="indent-8">
        “The twinkling of the <i>what?</i>” said the King.
      </p>
      <p className="indent-8">
        “It <i>began</i> with the tea,” the Hatter replied.
      </p>
      <p className="indent-8">
        “Of course twinkling begins with a T!” said the King sharply.
        “Do you take me for a dunce? Go on!”
      </p>
      <p className="indent-8">
        “I’m a poor man,” the Hatter went on, “and most things
        twinkled after that—only the March Hare said—”
      </p>
      <p className="indent-8">
        “I didn’t!” the March Hare interrupted in a great hurry.
      </p>
      <p className="indent-8">
        “You did!” said the Hatter.
      </p>
      <p className="indent-8">
        “I deny it!” said the March Hare.
      </p>
      <p className="indent-8">
        “He denies it,” said the King: “leave out that part.”
      </p>
      <p className="indent-8">
        “Well, at any rate, the Dormouse said—” the Hatter went on,
        looking anxiously round to see if he would deny it too: but the Dormouse denied
        nothing, being fast asleep.
      </p>
      <p className="indent-8">
        “After that,” continued the Hatter, “I cut some more
        bread-and-butter—”
      </p>
      <p className="indent-8">
        “But what did the Dormouse say?” one of the jury asked.
      </p>
      <p className="indent-8">
        “That I can’t remember,” said the Hatter.
      </p>
      <p className="indent-8">
        “You <i>must</i> remember,” remarked the King, “or I’ll
        have you executed.”
      </p>
      <p className="indent-8">
        The miserable Hatter dropped his teacup and bread-and-butter, and went down on
        one knee. “I’m a poor man, your Majesty,” he began.
      </p>
      <p className="indent-8">
        “You’re a <i>very</i> poor <i>speaker</i>,” said the King.
      </p>
      <p className="indent-8">
        Here one of the guinea-pigs cheered, and was immediately suppressed by the
        officers of the court. (As that is rather a hard word, I will just explain to
        you how it was done. They had a large canvas bag, which tied up at the mouth
        with strings: into this they slipped the guinea-pig, head first, and then sat
        upon it.)
      </p>
      <p className="indent-8">
        “I’m glad I’ve seen that done,” thought Alice.
        “I’ve so often read in the newspapers, at the end of trials,
        “There was some attempts at applause, which was immediately suppressed by
        the officers of the court,” and I never understood what it meant till
        now.”
      </p>
      <p className="indent-8">
        “If that’s all you know about it, you may stand down,”
        continued the King.
      </p>
      <p className="indent-8">
        “I can’t go no lower,” said the Hatter: “I’m on
        the floor, as it is.”
      </p>
      <p className="indent-8">
        “Then you may <i>sit</i> down,” the King replied.
      </p>
      <p className="indent-8">
        Here the other guinea-pig cheered, and was suppressed.
      </p>
      <p className="indent-8">
        “Come, that finished the guinea-pigs!” thought Alice. “Now we
        shall get on better.”
      </p>
      <p className="indent-8">
        “I’d rather finish my tea,” said the Hatter, with an anxious
        look at the Queen, who was reading the list of singers.
      </p>
      <p className="indent-8">
        “You may go,” said the King, and the Hatter hurriedly left the
        court, without even waiting to put his shoes on.
      </p>
      <p className="indent-8">
        “—and just take his head off outside,” the Queen added to one
        of the officers: but the Hatter was out of sight before the officer could get
        to the door.
      </p>
      <p className="indent-8">
        “Call the next witness!” said the King.
      </p>
      <p className="indent-8">
        The next witness was the Duchess’s cook. She carried the pepper-box in
        her hand, and Alice guessed who it was, even before she got into the court, by
        the way the people near the door began sneezing all at once.
      </p>
      <p className="indent-8">
        “Give your evidence,” said the King.
      </p>
      <p className="indent-8">
        “Shan’t,” said the cook.
      </p>
      <p className="indent-8">
        The King looked anxiously at the White Rabbit, who said in a low voice,
        “Your Majesty must cross-examine <i>this</i> witness.”
      </p>
      <p className="indent-8">
        “Well, if I must, I must,” the King said, with a melancholy air,
        and, after folding his arms and frowning at the cook till his eyes were nearly
        out of sight, he said in a deep voice, “What are tarts made of?”
      </p>
      <p className="indent-8">
        “Pepper, mostly,” said the cook.
      </p>
      <p className="indent-8">
        “Treacle,” said a sleepy voice behind her.
      </p>
      <p className="indent-8">
        “Collar that Dormouse,” the Queen shrieked out. “Behead that
        Dormouse! Turn that Dormouse out of court! Suppress him! Pinch him! Off with
        his whiskers!”
      </p>
      <p className="indent-8">
        For some minutes the whole court was in confusion, getting the Dormouse turned
        out, and, by the time they had settled down again, the cook had disappeared.
      </p>
      <p className="indent-8">
        “Never mind!” said the King, with an air of great relief.
        “Call the next witness.” And he added in an undertone to the Queen,
        “Really, my dear, <i>you</i> must cross-examine the next witness. It
        quite makes my forehead ache!”
      </p>
      <p className="indent-8">
        Alice watched the White Rabbit as he fumbled over the list, feeling very
        curious to see what the next witness would be like, “—for they
        haven’t got much evidence <i>yet</i>,” she said to herself. Imagine
        her surprise, when the White Rabbit read out, at the top of his shrill little
        voice, the name “Alice!”
      </p>
    </>
  )
}